export default __webpack_public_path__ + "static/media/icon-no-attestation.92cf6836.svg";